import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { ResponsiveHelpers } from '@phila/phila-ui';
import * as PhilaUI from '@phila/phila-ui';
import { i18n } from './i18n.js';
import VueGtag from "vue-gtag";
import axios from 'axios';
import './styles/app.scss';
import moment from 'moment';
import 'bulma/css/bulma.css';
import "core-js/stable";
import VModal from 'vue-js-modal';
Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.use(ResponsiveHelpers);
Vue.use(PhilaUI, {});
Vue.use(VModal);
Vue.use(VueGtag, {
  config: { id: "UA-860026-1" },
}, router);

axios.defaults.baseURL = process.env.VUE_APP_API_ROOT || '';

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format("MMM D, YYYY");
  }
});
new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');